var m = require('mithril');
var prop = require('mithril/stream');

var modal = require('../../layout/components/modal');
var key = require('../../libs/keybindings');

var state = {
  resource: null,
  unit: prop('indefinite'),
  value: prop(''),
  error: prop(null),
  saving: prop(false),
  onSave: function () {},
  onDisable: null
};

function resetState () {
  state.resource = null;
  state.unit('indefinite');
  state.value('');
  state.error(null);
  state.saving(false);
  state.onSave = function () {};
  state.onDisable = null;
}

function configureDefaults (expiresAt) {
  if (expiresAt && expiresAt > Date.now()) {
    var diffHours = Math.max(1, Math.round((expiresAt - Date.now()) / (60 * 60 * 1000)));
    if (diffHours >= 24 && diffHours % 24 === 0) {
      state.unit('days');
      state.value(String(Math.max(diffHours / 24, 1)));
    } else {
      state.unit('hours');
      state.value(String(diffHours));
    }
  } else {
    state.unit('indefinite');
    state.value('');
  }
  state.error(null);
  state.saving(false);
}

function setUnit (nextUnit) {
  state.unit(nextUnit);
  if (nextUnit === 'indefinite') {
    state.value('');
  }
}

function bodyView () {
  if (!state.resource) return m('div');
  var suppressed = Number(state.resource.suppressAuditNotifications) === 1;

  return m('div', [
    m('p.f5.mt0.mb3', suppressed
      ? 'Update how long audit notifications stay muted for this resource.'
      : 'Choose how long audit notifications should be muted for this resource.'),
    m('div.mb3', [
      m('label.db.mb2', 'Duration Type'),
      m('div.flex.flex-wrap', [
        ['indefinite', 'Indefinite'],
        ['hours', 'Hours'],
        ['days', 'Days']
      ].map(function (option) {
        var isActive = state.unit() === option[0];
        var classes = 'pointer ph3 pv2 br2 mr2 mb2 ' + (isActive ? 'bg-blue white' : 'bg-transparent white ba b--blue');
        return m('button', {
          type: 'button',
          class: classes,
          onclick: function () { setUnit(option[0]); }
        }, option[1]);
      }))
    ]),
    state.unit() !== 'indefinite' ? m('div.mb3', [
      m('label.db.mb2', 'Duration Value (' + state.unit() + ')'),
      m('input.form-control', {
        type: 'number',
        min: 1,
        value: state.value(),
        oninput: function (ev) { state.value(ev.target.value); }
      })
    ]) : null,
    state.error() ? m('div.mb3.bg-red.white.pa2.br2', state.error()) : null
  ]);
}

function closeModal () {
  modal.vm.close();
}

function runHandlerThenClose (handler, value) {
  if (state.saving()) return Promise.resolve();
  if (typeof handler !== 'function') {
    closeModal();
    return Promise.resolve();
  }

  state.saving(true);
  m.redraw();

  var result;
  try {
    result = handler(value);
  } catch (error) {
    result = Promise.reject(error);
  }

  return Promise.resolve(result)
    .then(function () {
      closeModal();
    })
    .catch(function (error) {
      state.saving(false);
      state.error((error && error.message) || 'Unable to update mute settings.');
      m.redraw();
      throw error;
    });
}

function save () {
  if (!state.resource) return;
  var unit = state.unit();
  var value = Number(state.value());
  var expiresAt = null;

  if (unit !== 'indefinite') {
    if (!value || Number.isNaN(value) || value <= 0) {
      state.error('Enter a positive number of ' + unit + '.');
      return;
    }
    var multiplier = unit === 'days' ? 24 : 1;
    expiresAt = Date.now() + value * multiplier * 60 * 60 * 1000;
  }

  state.error(null);
  var handler = state.onSave;
  return runHandlerThenClose(handler, expiresAt);
}

function disable () {
  var handler = state.onDisable;
  return runHandlerThenClose(handler);
}

module.exports = {
  open: function openSuppressionDurationModal (options) {
    options = options || {};
    state.resource = options.resource || null;
    if (!state.resource) return;

    state.onSave = typeof options.onSave === 'function' ? options.onSave : function () {};
    state.onDisable = typeof options.onDisable === 'function' ? options.onDisable : null;

    configureDefaults(options.expiresAt);

    var suppressed = Number(state.resource.suppressAuditNotifications) === 1;

    modal.vm.title(suppressed ? 'Update Mute Duration' : 'Mute Notifications');
    modal.vm.body = bodyView;

    var buttons = [
      {
        label: suppressed ? 'Update' : 'Mute',
        class: 'btn-good',
        func: save
      }
    ];

    if (suppressed) {
      buttons.unshift({
        label: 'Unmute',
        class: 'btn-good',
        func: disable
      });
    }

    modal.vm.buttons(buttons);

    key('enter', 'modal', save);
    modal.once('closed', function () {
      key.unbind('enter');
      resetState();
    });

    modal.vm.open();
  }
};
